
import { hideModal } from "global/context/action/modal/modal";
import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";
import CruzIcon from "_+_Portal/assets/images/generico/CruzIcon";
import { setOrigenMultitab, setPasoMultiTab } from "_+_Portal/context/Actions/multiTab/multiTab";
import { resetPaciente } from "_+_Portal/context/Actions/paciente/paciente";
import { resetTurnosPaciente } from "_+_Portal/context/Actions/turnos/turnosPaciente";
import { PortalContext } from "_+_Portal/context/Provider";
import { CardTitleContainer, ContainerSalir } from "./localStyle";
import "./OptionSidebar.css";

const CardSideBar = ({
  caption,
  items,
  expanded,
  headerClickHandler,
  handleClickLogout,
  posicionSidebar,
}) => {
  const {
    modalDispatch,
    multiTabDispatch,
    multiTabState,
    pacienteDispatch,
  } = useContext(PortalContext);

  const { turnosPacienteDispatch } = useContext(PortalContext);

  const history = useHistory();
  const [selected, setSelected] = useState();

  const handleClickMenu = (val) => {
    if (val.title === "Ayuda") {
      window.open("https://wa.me/+5491166485555", "_blank");
      return;
    }

    if (val.key === 7 || val.key === 5) {
      setOrigenMultitab(val.key)(multiTabDispatch);
    } else {
      setOrigenMultitab(null)(multiTabDispatch);
    }

    setPasoMultiTab(val.key)(multiTabDispatch);
    setSelected(val.key);
    history.push(val.link);
    hideModal()(modalDispatch);
  };

  useEffect(() => {
    setSelected(multiTabState.multiTab.paso);
  }, [multiTabState]);

  useEffect(() => {
    if (posicionSidebar !== undefined) {
      setPasoMultiTab(posicionSidebar)(multiTabDispatch);
    }
    // eslint-disable-next-line
  }, []);

  const reiniciarPaciente = () => {
    //esta es la linea que afectaba
    resetPaciente()(pacienteDispatch);
    resetTurnosPaciente()(turnosPacienteDispatch);
    history.push("/home");
  };

  return (
    <React.Fragment>
      <div
        className={`ptur-sidebarOption noSeleccionable ${
          caption === "Turnos"
            ? "turnosMobileSidebar bgc-white"
            : "resultadosMobileSidebar bgc-white"
        }`}
      >
        <CardTitleContainer className="bgc-white">
          <p className="rb18b c-black10">Paciente:</p>
          <span className="rb16b c-black10">{caption}</span>
          <ContainerSalir
            className="pointer"
            onClick={() => reiniciarPaciente()}
          >
            <CruzIcon color={"var(--color-grey45)"}></CruzIcon>
          </ContainerSalir>
        </CardTitleContainer>

        {true && (
          <ul className={`SidebarList dropdownSidebar`}>
            {items.map((val, index) => {
              const itemSelected = selected === val.key;
              return (
                <li
                  className="row bgc-white "
                  key={`Menu-${index}`}
                  id={itemSelected ? "active" : ""}
                  onClick={
                    val.title === "Salir"
                      ? () => handleClickLogout()
                      : () => handleClickMenu(val)
                  }
                >
                  {val.icon && (
                    <div
                      className={
                        itemSelected
                          ? "icon-option-sidebar img-option img-option-color"
                          : "icon-option-sidebar img-option"
                      }
                    >
                      {React.createElement(
                        require("../../../assets/images/generico/" + val.icon)
                          .default,
                        { color: "var(--color-latex10)", height: "25" }
                      )}
                    </div>
                  )}
                  <div id={itemSelected ? "flechaSideBar" : ""}></div>
                  <div id={itemSelected ? "margin" : "noMargin"}></div>
                  <div id="title" className="rb16l">
                    {val.title}
                  </div>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </React.Fragment>
  );
};

export default CardSideBar;
